import React, { useEffect, useState } from 'react';
import { Box, HStack, Hidden, Stack, VStack } from 'native-base';
import { Typography, logUserEvent, Iconography, EmptyBoxIcon, ToolTip } from 'fmc-digital-common';
import { dynamicFilterLabel, getFilteredList, getInitialFliterValue, getTaskCount, setFilterValue } from '../../../loaninprogress/utils';
import { FilterDropDown, TaskCardMobile } from '../../molecules';
import { amplifyLogs } from '../../../amplifyLogs';
import { TaskConstants } from '../../../constants';
export default (({
  listData,
  selectedCard,
  handleToggle
}) => {
  const initialFilter = getInitialFliterValue(listData);
  const [filteredList, setFilterdList] = useState(initialFilter === 'To Do' ? getFilteredList('To Do', listData) : listData);
  const [selectedFilter, setSelectedFilter] = useState(initialFilter ? initialFilter : '');
  const taskCount = getTaskCount(filteredList, selectedFilter);
  let showFilterText = '';
  if (taskCount && taskCount > 0) {
    showFilterText = `${selectedFilter} (${taskCount})`;
  } else {
    showFilterText = `${selectedFilter} (0)`;
  }
  const getSelectedFilter = value => {
    logUserEvent(amplifyLogs.filterByDropdown);
    setSelectedFilter(value);
    const filteredData = setFilterValue(value, listData);
    setFilterdList(filteredData);
  };
  const getFilterDropdown = () => {
    return /*#__PURE__*/React.createElement(Stack, {
      marginBottom: 4,
      accessibilityLabel: `${selectedFilter}filter`,
      accessibilityRole: "menuitem",
      testID: selectedFilter
    }, /*#__PURE__*/React.createElement(FilterDropDown, {
      options: dynamicFilterLabel(listData),
      onSelect: function (value) {
        logUserEvent(amplifyLogs.filterByDropdown);
        setSelectedFilter(value);
        getSelectedFilter(value);
      },
      initialFilter: showFilterText,
      key: taskCount
    }));
  };
  useEffect(() => {
    const filteredData = getFilteredList(selectedFilter, listData);
    setFilterdList(filteredData);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [listData]);
  return /*#__PURE__*/React.createElement(Box, {
    borderColor: 'lightBlue.400',
    borderRadius: '4',
    borderWidth: 1,
    p: 2,
    backgroundColor: 'white.500',
    width: '100%'
  }, /*#__PURE__*/React.createElement(Hidden, {
    till: "md"
  }, /*#__PURE__*/React.createElement(HStack, {
    space: 4,
    justifyContent: 'space-between'
  }, /*#__PURE__*/React.createElement(HStack, {
    alignItems: 'center',
    width: 60
  }, /*#__PURE__*/React.createElement(Typography, {
    testID: "tableTitle",
    variant: "title2",
    color: "darkGray.900",
    accessibilityLabel: "Tasks",
    accessibilityRole: "text"
  }, "Tasks"), /*#__PURE__*/React.createElement(Box, {
    display: 'flex-end',
    mt: 2,
    ml: 1
  }, /*#__PURE__*/React.createElement(ToolTip, {
    label: TaskConstants.TasksInfoMessage,
    placement: "bottom"
  }, /*#__PURE__*/React.createElement(Iconography, {
    name: "info",
    size: 21,
    color: "primary.500"
  })))), initialFilter ? /*#__PURE__*/React.createElement(HStack, {
    alignItems: 'center',
    space: 4
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "captionBold",
    textTransform: 'uppercase',
    testID: "filterText",
    accessibilityLabel: "filter By",
    accessibilityRole: "text"
  }, "filter By"), /*#__PURE__*/React.createElement(HStack, {
    accessibilityLabel: `${selectedFilter}filter`,
    accessibilityRole: "menuitem",
    testID: selectedFilter
  }, getFilterDropdown())) : null)), /*#__PURE__*/React.createElement(Hidden, {
    from: "md"
  }, /*#__PURE__*/React.createElement(VStack, null, /*#__PURE__*/React.createElement(HStack, {
    width: 80
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "title2",
    color: "darkGray.900"
  }, "Tasks"), /*#__PURE__*/React.createElement(Box, {
    display: 'flex-end',
    mt: 2,
    ml: 1
  }, /*#__PURE__*/React.createElement(ToolTip, {
    label: TaskConstants.TasksInfoMessage,
    placement: "bottom"
  }, /*#__PURE__*/React.createElement(Iconography, {
    name: "info",
    size: 21,
    color: "primary.500"
  })))), initialFilter ? /*#__PURE__*/React.createElement(HStack, {
    justifyContent: 'space-between'
  }, /*#__PURE__*/React.createElement(HStack, {
    space: 4,
    alignItems: 'center'
  }, /*#__PURE__*/React.createElement(Iconography, {
    name: 'filter-list',
    color: "review.500",
    size: 24
  })), /*#__PURE__*/React.createElement(HStack, {
    space: 4,
    alignItems: 'center'
  }, getFilterDropdown())) : null)), /*#__PURE__*/React.createElement(Box, {
    zIndex: -1,
    overflowY: 'visible'
  }, filteredList.length > 0 ? filteredList?.map((item, i) => /*#__PURE__*/React.createElement(TaskCardMobile, {
    item: item,
    index: i,
    handleToggle: handleToggle,
    selectedCard: selectedCard
  })) : /*#__PURE__*/React.createElement(Box, {
    width: '100%',
    height: 400,
    paddingTop: 24,
    zIndex: -1,
    overflowY: 'visible'
  }, /*#__PURE__*/React.createElement(VStack, {
    space: 2,
    alignItems: 'center',
    justifyContent: 'center'
  }, /*#__PURE__*/React.createElement(EmptyBoxIcon, {
    width: 86,
    height: 86
  }), /*#__PURE__*/React.createElement(Typography, {
    variant: "title2",
    color: "darkGray.900",
    accessibilityLabel: "NoTasks",
    accessibilityRole: "text",
    testID: "NoTasks"
  }, "You have no tasks"), /*#__PURE__*/React.createElement(Typography, {
    variant: "title2",
    color: "darkGray.900",
    accessibilityLabel: `NoTasks${selectedFilter}`,
    accessibilityRole: "text",
    testID: `NoTasks${selectedFilter}`
  }, `${selectedFilter.toLowerCase()}.`)))));
});
//# sourceMappingURL=Tasks.js.map